import React, { useContext, useMemo, createContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useTranslationHook } from "./TranslationHook";
export const TranslationContext = /*#__PURE__*/createContext({});
export const TranslationProvider = ({
  children,
  resourceBundle
}) => {
  const hook = useTranslationHook(resourceBundle);
  const context = useMemo(() => ({
    resourceBundle,
    ...hook
  }), [hook.resourceBundle]);
  return /*#__PURE__*/React.createElement(TranslationContext.Provider, {
    value: context
  }, children);
};
export const useTranslation = () => {
  return useContext(TranslationContext);
};
TranslationProvider.propTypes = {
  resourceBundle: PropTypes.object,
  children: PropTypes.node.isRequired
};
TranslationProvider.defaultProps = {
  resourceBundle: {}
};